/**
 * ROC 7
 * Copyright 2018 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('modules/Delivery/TotalQuantityAndPrice',[
        'jquery',
        'lodash',
        'global/all',
        'plugins/accounting.min',
        'plugins/jquery.matchHeights' 
    ],function ($, _, Roc, accounting) {
        'use strict';

        function handleQuantityChangeEvt(event) {
            var productId = $(event.target).attr('data-roc-productId');
            var quantity = parseInt($(event.target).val());
            handleQuantityChange(productId, quantity);
        }

        function handleQuantityChange(productId, quantity) {
            if (!quantity) {
                var quantitySelector = '.purchaseQuantity[data-roc-productId="' + productId + '"]';
                quantity = $(quantitySelector).val();
                if (!quantity) {
                    var groupId = $('#hdnGroupId').val();
                    productId = groupId;
                    var $quantity = $('.purchaseQuantity[data-roc-productId="' + groupId + '"]');
                    quantity = parseInt($quantity.val());
                } 
            } 
            updateTotalPrice(productId, quantity); 
        } 

        function updateTotalPrice(productId, quantity) {
            var priceSelector = '.itemPrice[data-product-id="' + productId + '"]';
            var price = $(priceSelector);

            if (!price || price.length < 1) {
                priceSelector = 'div.itemPrice > div > div.currentPrice > strong.price';
                price = $(priceSelector);
            }

            var totalPriceSelector = '.price[data-roc-productId="' + productId + '"]';
            var parsedPrice = accounting.unformat(price.html()); 
            var totalPrice = parsedPrice * quantity;
            $(totalPriceSelector).html(accounting.formatMoney(totalPrice));
        }

        function bindEvents() {
            $('.purchaseQuantity').off("change");
            $('.purchaseQuantity').on("change", handleQuantityChangeEvt);

            Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE,
                function (productViewModel) {
                    handleQuantityChange(productViewModel.id);
                });
        }

        function init() {
            bindEvents();
        }

        function initProductDetailsPage() {
            var quantityFieldProductId = $('#purchaseQuantity').attr('data-roc-productId');
            handleQuantityChange(quantityFieldProductId);
            init();
        }

        var TotalQuantityAndPrice = {
            handleQuantityChangeEvt: handleQuantityChangeEvt,
            handleQuantityChange: handleQuantityChange, 
            updateTotalPrice: updateTotalPrice,
            init: init,
            initProductDetailsPage: initProductDetailsPage
        }
        Roc.Logger.debug('TotalQuantityAndPrice.js Loaded:', TotalQuantityAndPrice);

        return TotalQuantityAndPrice;

    });
